import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import Navbar from 'react-bootstrap/lib/Navbar';
import { motion, AnimatePresence } from 'framer-motion';
import { Search, X, Sparkles, MapPin } from 'lucide-react';

import Navigation from '../Navigation';
import Logo from '../Logo';
import Toaster from '../Toaster';
import DropDownMenu from '../DropDownMenu/DropDownMenu';
import LoadingBar from 'react-redux-loading-bar';
import HeaderModal from '../HeaderModal';
import HeaderSearchBar from './HeaderSearchBar';

import history from '../../core/history';
import { toggleOpen, toggleClose } from '../../actions/Menu/toggleControl';
import { openHeaderModal } from '../../actions/modalActions';

import currencyIcon from '/public/SiteIcons/currencyIcon.svg';

import s from './Header.css';

class HomeHeader extends React.Component {
  static propTypes = {
    borderLess: PropTypes.bool,
    showMenu: PropTypes.bool,
    toggleOpen: PropTypes.any.isRequired,
    formatMessage: PropTypes.any,
  };

  static defaultProps = {
    borderLess: false,
    showMenu: false,
    searchDisablePages: [
      '/',
      '/home'
    ]
  }

  constructor(props) {
    super(props);
    this.state = {
      searchHide: true,
      load: false,
      isOpen: false,
      isScrolled: false,
      isMobile: false,
      mobileSearchOpen: false,
      mobileSearchQuery: '',
      // Sticky search state
      stickySearchQuery: '',
      stickyInputFocused: false,
      currentPlaceholder: 'Yate en Miami para 10 personas...',
      placeholderIndex: 0,
    };
    this.handleScroll = this.handleScroll.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.handleStickyInputChange = this.handleStickyInputChange.bind(this);
    this.handleStickyInputFocus = this.handleStickyInputFocus.bind(this);
    this.handleStickyInputBlur = this.handleStickyInputBlur.bind(this);
    this.handleStickySearch = this.handleStickySearch.bind(this);
    
    // Placeholder phrases
    this.placeholderPhrases = [
      'Yate en Miami para 10 personas...',
      'Velero romántico en Cap Cana...',
      'Pesca deportiva en Culebra...',
      'Fiesta en yate para 20 invitados...',
      'Catamarán familiar en Ibiza...'
    ];
  }

  componentDidMount() {
    this.setState({
      load: true,
      isMobile: typeof window !== 'undefined' && window.innerWidth < 768
    });
    this.handleDisableSearchPages();
    
    // AUTÓNOMO: Scroll listener interno
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize);
      this.handleScroll();
    }
    
    // Start placeholder rotation
    this.startPlaceholderRotation();
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
    }
    // Clear placeholder interval
    if (this.placeholderInterval) {
      clearInterval(this.placeholderInterval);
    }
  }

  handleScroll() {
    // SYNC: Threshold aumentado para retrasar sticky header
    const threshold = 400;
    const scrollY = window.scrollY || window.pageYOffset;
    const isScrolled = scrollY > threshold;
    if (this.state.isScrolled !== isScrolled) {
      this.setState({ isScrolled });
    }
  }

  handleResize() {
    const isMobile = window.innerWidth < 768;
    if (this.state.isMobile !== isMobile) {
      this.setState({ isMobile });
    }
  }

  openMobileSearch = () => {
    this.setState({ mobileSearchOpen: true });
    document.body.style.overflow = 'hidden';
  }

  closeMobileSearch = () => {
    this.setState({ mobileSearchOpen: false, mobileSearchQuery: '' });
    document.body.style.overflow = '';
  }

  handleMobileSearch = (e) => {
    e && e.preventDefault();
    const { mobileSearchQuery } = this.state;
    if (!mobileSearchQuery.trim()) return;
    const params = new URLSearchParams();
    params.set('address', mobileSearchQuery.trim());
    params.set('chosen', '1');
    this.closeMobileSearch();
    history.push(`/s?${params.toString()}`);
  }

  // Sticky search handlers
  handleStickyInputChange(e) {
    this.setState({ stickySearchQuery: e.target.value });
  }

  handleStickyInputFocus() {
    this.setState({ stickyInputFocused: true });
    // Stop placeholder rotation when focused
    if (this.placeholderInterval) {
      clearInterval(this.placeholderInterval);
    }
  }

  handleStickyInputBlur() {
    this.setState({ stickyInputFocused: false });
    // Restart placeholder rotation when blurred
    this.startPlaceholderRotation();
  }

  handleStickySearch(e) {
    e && e.preventDefault();
    const { stickySearchQuery } = this.state;
    if (!stickySearchQuery.trim()) return;
    const params = new URLSearchParams();
    params.set('address', stickySearchQuery.trim());
    params.set('chosen', '1');
    history.push(`/s?${params.toString()}`);
  }

  startPlaceholderRotation() {
    this.placeholderInterval = setInterval(() => {
      this.setState(prevState => {
        const nextIndex = (prevState.placeholderIndex + 1) % this.placeholderPhrases.length;
        return {
          placeholderIndex: nextIndex,
          currentPlaceholder: this.placeholderPhrases[nextIndex]
        };
      });
    }, 3000);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.handleDisableSearchPages();
  }

  handleMenu = () => {
    const { showMenu, toggleOpen, toggleClose } = this.props;
    if (showMenu) {
      toggleClose();
    } else {
      toggleOpen();
    }
  }

  handleDisableSearchPages = () => {
    const { searchDisablePages } = this.props;
    let location = history.location ? history.location.pathname : null;
    let searchHide = false;
    if (location && searchDisablePages.length > 0) {
      searchHide = searchDisablePages.find((o) => location === o);
      searchHide = (searchHide) ? true : false;
    }

    this.setState({
      searchHide
    })
  }
  openMenu = async () => {
    this.setState({
      isOpen: true,
    })
    document.body.classList.add('headerModalOpen');
  }

  openClose = async () => {
    this.setState({
      isOpen: false,
    })
    document.body.classList.remove('headerModalOpen');
  }

  render() {
    const { borderLess, showMenu, layoutType } = this.props;
    const { load, isScrolled, isMobile, mobileSearchOpen, mobileSearchQuery, stickySearchQuery, stickyInputFocused, currentPlaceholder } = this.state;

    let borderClass, headerDesignClass, location;
    // Detectar home page incluyendo prefijos de idioma (/es/, /en/, /fr/, /it/, /pt/)
    const pathname = history.location?.pathname || '';
    const isHomePage = pathname === '/' || 
                       pathname === '/home' || 
                       /^\/(es|en|fr|it|pt)\/?$/.test(pathname) ||
                       /^\/(es|en|fr|it|pt)\/home\/?$/.test(pathname);

    if (borderLess) {
      borderClass = s.rentAllHeaderBorderLess;
    }

    if (layoutType && (layoutType == 1 || layoutType == 3 || layoutType == 4 || layoutType == 5)) {
      headerDesignClass = 'headerNewDesign';
    }

    if (history.location) {
      location = history.location.pathname;
    }

    return (
      <div className={headerDesignClass}>
        <div className={s.root}>
          <Toaster />
          <LoadingBar />
          <Navbar className={cx(
            s.rentAllHeader, 
            'rentAllHeader', 
            borderClass, 
            s.headerFlexContainer, 
            { [s.fixedHeader]: location === '/s' }, 
            { ['homeHeader']: isHomePage },
            { [s.stickyHeader]: isHomePage && isScrolled }
          )}
            expanded={showMenu} onToggle={this.handleMenu}>
            <div className={cx(s.container, s.headerFlexBox)}>
              {/* Logo - Left */}
              <Navbar.Header className={cx('logoPadding', !showMenu ? 'normalPosition' : 'fixedPosition', { [s.stickyLogo]: isScrolled })}>
                <Navbar.Brand className={cx(s.homeLogo, 'navBrandRTL')}>
                  <Logo link={"/"} className={cx(s.brand, s.brandImg)} load={load} />
                </Navbar.Brand>
              </Navbar.Header>
              
              {/* PREMIUM Search Bar - Desktop: editable directamente, placeholders dinámicos */}
              <AnimatePresence>
                {isHomePage && isScrolled && !isMobile && (
                  <motion.div
                    className={s.headerSearchCenter}
                    initial={{ opacity: 0, y: -15 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -10 }}
                    transition={{ 
                      duration: 0.4, 
                      ease: [0.4, 0, 0.2, 1]
                    }}
                  >
                    <form onSubmit={this.handleStickySearch} className={s.premiumSearchContainer}>
                      <Search size={18} className={s.premiumSearchIcon} />
                      <input
                        type="text"
                        className={s.premiumSearchInput}
                        value={stickySearchQuery}
                        onChange={this.handleStickyInputChange}
                        onFocus={this.handleStickyInputFocus}
                        onBlur={this.handleStickyInputBlur}
                        placeholder={!stickyInputFocused ? currentPlaceholder : 'Escribe tu búsqueda...'}
                      />
                      <button 
                        type="submit"
                        className={s.premiumSearchButton}
                      >
                        <Sparkles size={14} />
                        <span>Buscar</span>
                      </button>
                    </form>
                  </motion.div>
                )}
              </AnimatePresence>
              
              {/* Mobile Sticky: Buscador directo solo con lupa (sin menú ni idioma) */}
              <AnimatePresence>
                {isHomePage && isScrolled && isMobile && (
                  <motion.form
                    className={s.mobileStickySearch}
                    onSubmit={this.handleStickySearch}
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -10 }}
                    transition={{ duration: 0.25 }}
                  >
                    <Search size={18} className={s.mobileStickyIcon} />
                    <input
                      type="text"
                      className={s.mobileStickyInput}
                      value={stickySearchQuery}
                      onChange={this.handleStickyInputChange}
                      onFocus={this.handleStickyInputFocus}
                      onBlur={this.handleStickyInputBlur}
                      placeholder={currentPlaceholder}
                    />
                    <button type="submit" className={s.mobileStickyBtn}>
                      <Sparkles size={14} />
                    </button>
                  </motion.form>
                )}
              </AnimatePresence>
              
              {/* Menu/Language buttons - OCULTAR en móvil sticky */}
              <div className={cx(s.mobileHeaderActions, { [s.hiddenInStickyMobile]: isScrolled && isMobile })}>
                {/* Language button - visible only on mobile */}
                <div 
                  className={cx(s.mobileLanguageBtn, 'hidden-lg hidden-md')}
                  onClick={(e) => { e.stopPropagation(); this.props.openHeaderModal('languageModal'); }}
                >
                  <img src={currencyIcon} alt="Language" />
                </div>
                <div onClick={() => this.openMenu()} className={cx({ [s.stickyNav]: isScrolled })}>
                  <div className={'closebtnHidden'}>
                    <DropDownMenu homeHeaderOnly={true} />
                  </div>
                </div>
              </div>
              <HeaderModal />
              <div className={cx(`${(this.state.isOpen === true) ? s.menuOpen : s.menuClose}`, s.mobileMenu)}>
                <div className={cx(s.rightMenuClose, 'closebtnHidden')}>
                  <div className={s.closeButtonPosition}>
                    <div className={cx(s.closeColor, s.cPointer, 'closeColorRTL')} onClick={() => this.openClose()} >
                      ×
                    </div>
                  </div>
                </div>
                <div onClick={() => this.openClose()}>
                  <Navigation openClose={this.state.isOpen} homeHeaderOnly={true} />
                </div>
              </div>
            </div>
          </Navbar>
        </div>
        
        {/* Mobile Search Modal */}
        <AnimatePresence>
          {mobileSearchOpen && (
            <motion.div
              className={s.mobileSearchOverlay}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.2 }}
            >
              <motion.div
                className={s.mobileSearchModal}
                initial={{ y: -100, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                exit={{ y: -100, opacity: 0 }}
                transition={{ duration: 0.3, ease: [0.4, 0, 0.2, 1] }}
              >
                <button 
                  className={s.mobileSearchClose}
                  onClick={this.closeMobileSearch}
                  aria-label="Cerrar búsqueda"
                >
                  <X size={24} />
                </button>
                <form onSubmit={this.handleMobileSearch} className={s.mobileSearchForm}>
                  <div className={s.mobileSearchInputWrapper}>
                    <MapPin size={20} className={s.mobileSearchPinIcon} />
                    <input
                      type="text"
                      className={s.mobileSearchInput}
                      value={mobileSearchQuery}
                      onChange={(e) => this.setState({ mobileSearchQuery: e.target.value })}
                      placeholder="¿A dónde quieres navegar?"
                      autoFocus
                    />
                  </div>
                  <motion.button
                    type="submit"
                    className={s.mobileSearchSubmit}
                    whileTap={{ scale: 0.98 }}
                  >
                    <Sparkles size={18} />
                    <span>Buscar con IA</span>
                  </motion.button>
                </form>
                <div className={s.mobileSearchSuggestions}>
                  <p className={s.mobileSearchSuggestionsTitle}>Búsquedas populares</p>
                  <div className={s.mobileSearchChips}>
                    {['Miami', 'Cap Cana', 'Cartagena', 'Cancún'].map((place) => (
                      <button
                        key={place}
                        className={s.mobileSearchChip}
                        onClick={() => {
                          this.setState({ mobileSearchQuery: place }, () => {
                            this.handleMobileSearch();
                          });
                        }}
                        type="button"
                      >
                        {place}
                      </button>
                    ))}
                  </div>
                </div>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    );
  }
}

const mapState = (state) => ({
  siteSettings: state?.siteSettings?.data,
  layoutType: state?.siteSettings?.data?.homePageType,
  showMenu: state?.toggle?.showMenu
});

const mapDispatch = {
  toggleOpen,
  toggleClose,
  openHeaderModal
};

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(HomeHeader)));